import { useApolloClient, useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BulkUpdateDealRboConfigDocument } from '../../../graphql/mutation/deals/BulkUpdateDealRboConfig.generated.tsx';

export const useDealDisableRbo = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const client = useApolloClient();
  const [bulkUpdateRboConfig, { loading: isDisabling }] = useMutation(BulkUpdateDealRboConfigDocument);

  const disableDealsRbo = useCallback(
    async (dealIds: string[]) => {
      const input = dealIds.map(deal_id => ({
        deal_id,
        rbo_config: null,
      }));

      const result = await bulkUpdateRboConfig({
        variables: { input },
      });

      const results = result.data?.bulkUpdateDealRboConfig || [];
      const failures = results.filter(r => r.__typename === 'BulkRboUpdateError');
      const successes = results.filter(r => r.__typename === 'BulkRboUpdateSuccess');

      if (failures.length > 0) {
        const errorMessage = t('Failed to disable RBO for {count} deal(s)', { count: failures.length });
        enqueueSnackbar(errorMessage, { variant: 'error' });
        throw new Error(errorMessage);
      }

      await client.refetchQueries({
        include: ['GetDealsList', 'GetDeal'],
      });

      enqueueSnackbar(t('Successfully disabled RBO for {count} deal(s)', { count: successes.length }), {
        variant: 'success',
      });
    },
    [client, bulkUpdateRboConfig, enqueueSnackbar, t]
  );

  return { disableDealsRbo, isDisabling };
};
